import find from 'lodash/find';
import createTaxonomyListFromQuery from './createTaxonomyListFromQuery';

export default (query, _type, slug) => {
	const queryTaxonomyList = createTaxonomyListFromQuery(query);
	
	return !!find(queryTaxonomyList, {
		_type,
		slug,
	});
};